import type { GuestCatalogType } from "@/hooks/useGuestOpacTenantSlug";

export function getGuestCatalogEmptyMessage(
  searchQuery: string,
  type: GuestCatalogType
): {
  title: string;
  hint: string;
} {
  if (searchQuery) {
    return {
      title: "No matches found",
      hint: `Try different keywords or clear the search to browse the full catalog.`,
    };
  }
  switch (type) {
    case "digital":
      return {
        title: "No digital resources yet",
        hint: "Published e-books and documents will appear here when the library adds them.",
      };
    case "journal":
      return {
        title: "No journals published",
        hint: "Check back later or browse all types to see what is available.",
      };
    case "physical":
      return {
        title: "No books published",
        hint: "Check back later or browse all types to see what is available.",
      };
    default:
      return {
        title: "Nothing to show yet",
        hint: "The library has not published catalog items for public browsing.",
      };
  }
}
